import axios from "axios";
import React, { useState, useContext } from "react";
import { url } from "../utils/url";
import { useHistory, useParams } from "react-router-dom";
import Logged from "./Profile";
import TryLogin from "./TryLogin";
import UserContext from "../UserContext";
import { LoadingOutlined } from "@ant-design/icons";
import SidebarNav from "./navigation/SidebarNav";
const EditPost = () => {
  const { postid } = useParams();
  const { user, reloadRequests, posts } = useContext(UserContext);
  const history = useHistory();
  const [title, settitle] = useState();
  const [content, setcontent] = useState();
  const [post, setpost] = useState({});

  const [loading, setLoading] = useState(false);

  const handletitle = (e) => {
    settitle(e.target.value);
  };
  const handlecontent = (e) => {
    setcontent(e.target.value);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    await axios
      .put(
        `${url}/api/posts/updatepost/${post._id}`,
        {
          title,
          content,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      )
      .then((res) => {
        window.Toast.fire({
          icon: "success",
          title: "Post udpated!",
        });
        reloadRequests();
        history.push("/");
      })
      .catch((err) => {
        setLoading(true);
        window.displayToastError("Operation failed.");
      });
    setLoading(true);
  }

  React.useEffect(() => {
    let tempPost = posts.find(
      (record) => record._id === postid && record.user_id === user.info._id
    );
    setpost(tempPost || {});
  }, [postid, user, posts]);

  return (
    <div className="flex justify-center w-full">
        <div className="px-2 grid grid-cols-1 lg:grid-cols-11 lg:w-3/4 lg:gap-10">
          <div className="lg:col-span-6 lg:grid grid-cols-7">
            <div className="top-0 sticky col-span-1 lg:h-screen">
              <div className="hidden lg:block">
                <SidebarNav />
              </div>
            </div>
            <div className="col-span-6">
              <form className="w-full " onSubmit={handleSubmit}>
                {post._id ? (
                  <>
                    <h1 className="text-sm font-bold mt-5 mb-3">
                      {" "}
                      🔥 Edit post
                    </h1>

                    <div className="form-group">
                      <label htmlFor="title">Title</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={post.title}
                        id="title"
                        value={title}
                        onChange={handletitle}
                        placeholder=""
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="content">Post</label>
                      <textarea
                        className="form-control"
                        id="content"
                        defaultValue={post.content}
                        rows="5"
                        value={content}
                        onChange={handlecontent}
                        placeholder=""
                      />
                    </div>
                    {!loading ? (
                      <button className="bg-fire text-white p-2 rounded focus:outline-none">
                        Update
                      </button>
                    ) : (
                      <button
                        className="btn bg-fire upda-btn opacity-50 text-white flex gap-4 items-center"
                        disabled
                      >
                        <LoadingOutlined />
                        <span> Updating ...</span>
                      </button>
                    )}
                  </>
                ) : (
                  <p>Loading post....</p>
                )}
              </form>
            </div>
          </div>
          <div className="lg:col-span-5">
            {user.token ? <Logged /> : <TryLogin />}
          </div>
        </div>
    </div>
  );
};
export default EditPost;
